module.exports = __webpack_public_path__ + "Surface_Pro_4.svg?ddc88683beac3f680acfaa4ddf458458";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/Surface_Pro_4.svg
// module id = 213
// module chunks = 0